/* eslint no-console: 0 */ // --> OFF

// import { generateGroupNameCode } from "../signalrStarter";
import {
  GET_ROOM_RESULTS_SUCESS,
  GET_ROOM_RESULTS_FAIL,
  GET_REGION_RESULTS_SUCCESS,
  GET_REGION_RESULTS_FAIL
} from "../constants/actionTypes";
import { push } from "react-router-redux";
import qs from "qs";

// summery: each room/region results fetching will go though this middleware
// to check if there are any room/region results - if don't - redirect to noresults route view
// and if do, and room results (not region) join to real-time hotel current viewer group
export const resultGettingMiddleware = ({
  dispatch,
  getState
}) => next => action => {
  const isRoomResults =
    action.type == GET_ROOM_RESULTS_SUCESS ||
    action.type == GET_ROOM_RESULTS_FAIL;
  const isRegionResults =
    action.type == GET_REGION_RESULTS_SUCCESS ||
    action.type == GET_REGION_RESULTS_FAIL;

  const { routing } = getState();
  const currentQuery = qs.parse(routing.location && routing.location.search, {
    ignoreQueryPrefix: true
  });
  const isDealMode = currentQuery.selectedDealId;
  if (isRoomResults || isRegionResults) {
    // if don't - go to 'noresults' view ( unmount searchresults and exc leave group proc )
    if (action.payload == null || action.payload.length == 0) {
      if (isDealMode == null) {
        dispatch(push("/noresults" + routing.location.search));
      }
    } else {
      if (isRoomResults) {
        // if do - join singalr realtime hotel group
        const { selectedHotelId: hotelId, lang } = getState();
        try {
          window._hub.invoke("joinGroup", `H${hotelId}`, lang);

          //window._hub.invoke("joinGroup", generateGroupNameCode(hotelId), lang);
        } catch (error) {
          console.log("signalR joinGroup invoke failed", error); // eslint-disable-line no-console
        }
      }
    }
  }
  next(action);
};



// WEBPACK FOOTER //
// ./src/middlewares/resultGettingMiddleware.js